import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "line-clamp ellipsis q-px-md sfx-table__td-text" }

import { ColumnAlignment, StringOrFunction } from "src/util/types/components/sfxTable"
import { computed, PropType, ref, watch } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxTableTd',
  props: {
  text: [String, Number, Boolean, Promise<string | number | boolean>],

  emptyText: [String, Function] as PropType<StringOrFunction>,

  align: {
    type: String as PropType<ColumnAlignment>,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const textValue = ref<typeof props.text>()
const textClass = computed(() => (textValue.value != null ? "text-body2" : "text-no-value"))
const emptyTextValue = computed(() => {
  if (!props.emptyText) return
  else if (typeof props.emptyText === "function") return props.emptyText()
  else return props.emptyText
})

// Set the default alignment to be center
const columnAlignmentClass = computed(() => `text-${props.align || "center"}`)
const columnCustomClasses = computed(() => [textClass.value, columnAlignmentClass.value])

//endregion

//region Setup Code

watch(
  () => props.text,
  async (val) => {
    textValue.value = await Promise.resolve(val)
  },
  { immediate: true }
)

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_td = _resolveComponent("q-td")!

  return (_openBlock(), _createBlock(_component_q_td, {
    class: _normalizeClass(["sfx-table__td", columnCustomClasses.value])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "prepend"),
          (textValue.value != null)
            ? _renderSlot(_ctx.$slots, "value", { key: 0 }, () => [
                _createTextVNode(_toDisplayString(textValue.value), 1)
              ])
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(emptyTextValue.value || _ctx.$t("sfxTable.empty_no_value")), 1)
              ], 64)),
          _renderSlot(_ctx.$slots, "append")
        ])
      ])
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})